<template>
  <form @submit.prevent="onSubmit">
    <p class="pr-4">
      {{ order.city.paymentScreen }}
    </p>
    <b-row align-v="end">
      <b-col>
        <label for="discount-input">
          {{ $t('discount.text') }}
          <b-button id="discount-info" class="tooltip-btn" :title="$t('discount.title')">
            <fa-icon size="sm" :icon="['fas', 'info-circle']" class="tooltip-info"/>
          </b-button>
          <b-tooltip target="discount-info" triggers="hover click blur" placement="right">
            {{ $t('discount.notApplyTip') }}
          </b-tooltip>
        </label>
        <form-input v-if="order.discount" id="discount-input" :placeholder="order.discount.code" disabled />
        <form-input v-else id="discount-input" v-model="input" placeholder="Enter Code" :disabled="discountState.loading" />
      </b-col>
      <b-col cols="4">
        <b-button type="submit" variant="primary" block :disabled="discountState.loading || (!input && !order.discount)">
          {{ order.discount ? 'Remove' : 'Apply' }}
          <div v-if="discountState.loading" role="status" class="fa-pulse float-right mt-1">
            <fa-icon :icon="['fas', 'spinner']" class="d-flex" />
            <span class="sr-only">{{ $t('dp.buttons.loading') }}</span>
          </div>
        </b-button>
      </b-col>
    </b-row>
    <h4 v-if="discountState.success && promoCodeExcludesSaleItems && hasOnSaleItems" class="text-danger mt-2 mb-0">
      {{ $t('discount.excludesSaleItems') }}
    </h4>
    <h4 v-if="discountState.success" class="text-success mt-2 mb-0">{{ discountState.success }}</h4>
    <h4 v-else-if="discountState.error" class="text-danger mt-2 mb-0">{{ discountState.error }}</h4>
  </form>
</template>

<script>
import formInput from '@/components/basket/FormInput';

export default {
  components: {
    formInput,
  },
  props: {
    order: {
      type: Object,
      required: true,
      default: null,
    },
    discountState: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      input: '',
    };
  },
  computed: {
    promoCodeExcludesSaleItems() {
      return this.order?.discount?.code && !this.order.discount.includeSaleItems;
    },
    hasOnSaleItems() {
      return this.order?.items?.some((item) => Number(item.product?.discountedPrice) > 0 && item.product?.type === 'DESIGNER_TAG');
    },
  },
  methods: {
    onSubmit() {
      this.$emit('applyDiscount', this.input);
    },
    removeDiscount() {
      this.input = '';
    },
  },
};
</script>

<style></style>
